import { render, staticRenderFns } from "./forgot-password-page.html?vue&type=template&id=7c04fb22&external"
import script from "./forgot-password-page.js?vue&type=script&lang=js&external"
export * from "./forgot-password-page.js?vue&type=script&lang=js&external"
import style0 from "./forgot-password-page.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports